import { EXTRA_SINGAL } from "@/commons/enums/extra-singal";
import { BasicControl, CURSOR_TYPE, dymode, DYMODE_MODE, FatLine, LineSegments2, LineT, Listeners, MOUSE, Point, PrimitiveColor, TnEngineContext, TnEngineExtraContext, ViewEditor } from "pytha";
import { Color, Line, LineDashedMaterial, Material, Object3D, Object3DEventMap, Quaternion, Vector3 } from "three";


const STEP = {
    0: { 'tip': '选择对象', 'mode': DYMODE_MODE.TIPONLY },
    1: { 'tip': '指定基点', 'mode': DYMODE_MODE.POINT },
    2: { 'tip': '指定第二个点（距离）', 'mode': DYMODE_MODE.DIST },
}

interface RenderMap {
    material: Material
    positions: number[]
    colors: number[]
    object?: Object3D
    renderType: string
    uvs?: number[]    //uv坐标
}

export class ObjMeshGroupMoveControl extends BasicControl {

    id: number = 10085;

    // 基点和第二个点
    point_first: Vector3 = new Vector3();
    point_second: Vector3 = new Vector3();

    step: number = 0;


    capturePoint: Vector3;

    dymodePoint: Vector3 = new Vector3();

    orthogonalPoint: Vector3;

    polarPoint: Vector3;

    line: LineT = new LineT();
    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    objMeshGroupUuids: string[] = [];
    objMeshGroups: Object3D<Object3DEventMap>[] = [];
    objMeshGroupFirstPoss: Vector3[] = [];


    helpDict: {};

    constructor(editor: ViewEditor, listeners: Listeners, isSubClass: boolean = false) {
        super();
        if (isSubClass) return;
        // 使用构造函数，在创建类的对象时，直接给成员变量赋值
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.editor = this.extraContext.getCurrentViewEditor();
        this.listeners = listeners;
        this.line._isHelpLine = true;
        this.line.color.set(PrimitiveColor.editColor)
        // 注册监听指针事件
        editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        // 派发置空选择集的信号
        // this.listeners.signals.emptySelectedEntities.dispatch();
        // 订阅选择信号，收听选择集信息
        // this.listeners.signals.onSelectChanged.add(this.onSelectChanged)
        // 订阅动态输入改变信号，收听到动态输入信息
        this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        // 订阅确认信号
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        // 订阅点捕捉信号，收听到捕捉点的坐标
        this.listeners.signals.onPointCapture.add(this.onPointCapture);
        // 订阅正交信号，收听到正交模式点的坐标
        this.listeners.signals.onPointOrthogonal.add(this.onPointOrthogonal);
        // 订阅极轴追踪信号，收听到极轴追踪点的坐标
        this.listeners.signals.onPointPolarTracking.add(this.onPointPolarTracking);
        // 激活选择
        this.editor.selectControl.setEnabled(true);
        // 激活动态输入
        this.extraContext.dymodeContext.enabled = true;
        this.editor.clampControl.enabled = false;
        this.editor.clampControl.hidden = true;

        this.step++;
        // 钝化选择
        this.editor.selectControl.setEnabled(false);
        // 派发需要捕捉的信号
        this.listeners.signals.needCapture.dispatch();
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);

        this.editor.listeners.signals.needRender.dispatch('redraw');
        this.point_first.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        this.point_second.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        // this.dymodePoint.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        console.log('MoveControl added')
    }

    dispose(): void {

        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        // this.listeners.signals.onSelectChanged.remove(this.onSelectChanged);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onPointOrthogonal.remove(this.onPointOrthogonal);
        this.listeners.signals.onPointPolarTracking.remove(this.onPointPolarTracking);
        this.listeners.signals.noNeedCapture.dispatch();
        this.listeners.getSignal(EXTRA_SINGAL.onObjMeshGroupChange).dispatch();
        // 派发置空选择集的信号
        this.listeners.signals.emptySelectedEntities.dispatch();
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        this.editor.clampControl.enabled = true;
        this.editor.clampControl.hidden = false;
        this.editor.orthogonalControl.enabled = false;
        this.editor.polarControl.enabled = false;
        let obj = this.line.viewObj;
        if (obj && !!obj.parent) {
            obj.parent.remove(obj);
        }


        // 新的销毁方式
        for (let key in this._copyEntitiyMap) {
            let mapItem = this._copyEntitiyMap[key];
            if (mapItem.object != null) {
                mapItem.object.parent?.remove(mapItem.object);
            }
        }
        delete this._copyEntitiyMap;
        this.editor.listeners.signals.needRender.dispatch('redraw');
        console.log('MoveControl removed')
    }

    initHelpLine = () => {
        this.line.set(this.point_first, this.point_second);
        this.line._isHelpLine = true;
        let viewObj: Line | FatLine | LineSegments2 = this.line.render();
        let size = this.context.renderContext.cameraEdge * this.context.renderContext.selectedDashScale * 5;
        viewObj.material = new LineDashedMaterial({ color: new Color('#d2a021'), dashSize: size, gapSize: size });
        this.extraContext.sceneContext.scene.add(viewObj);
    }

    onPointPolarTracking = (point) => {
        this.polarPoint = point;
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    onPointOrthogonal = (point) => {
        this.orthogonalPoint = point;
    }

    onPointerDown = (event) => {
        if (event.button !== MOUSE.LEFT) return;
        if (this.step === 0) {
            return;
        } else if (this.step === 1) {
            if (this.capturePoint) {
                this.point_first.copy(this.capturePoint);
            } else {
                this.point_first.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
            }
            this.firstStep();
            this.initHelpLine();
            this._pointLast.copy(this.point_first);
        } else if (this.step === 2) {
            if (this.capturePoint) {
                this.point_second.copy(this.capturePoint);
            } else if (this.orthogonalPoint) {
                this.point_second.copy(this.orthogonalPoint);
            } else if (this.polarPoint) {
                this.point_second.copy(this.polarPoint);
            } else {
                this.point_second.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
            }
            if (this.point_second.equals(this.point_first)) {
                this.point_second.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
            }
            this.lastStep();
        }
    }

    protected _moveDir = new Vector3();
    protected _pointLast = new Point();

    onPointerMove = (event) => {
        this.dymodePoint.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);

        if (this.step === 2) {
            if (this.orthogonalPoint) {
                this.dymodePoint.copy(this.orthogonalPoint);
            }
            if (this.polarPoint) {
                this.dymodePoint.copy(this.polarPoint);
            }
            if (this.capturePoint) {
                this.dymodePoint.copy(this.capturePoint);
            }
            this.line.set(this.point_first, this.dymodePoint);
            this.line.updateViewGeometry();


            const x = this.dymodePoint.x - this.point_first.x;
            const y = this.dymodePoint.y - this.point_first.y;
            const z = this.dymodePoint.z - this.point_first.z;
            for (let key in this._copyEntitiyMap) {
                let mapItem = this._copyEntitiyMap[key];
                if (mapItem.object == null) continue;
                mapItem.object.position.set(x, y, z);
            }
            this.objMeshGroups.forEach((objMeshGroup, index) => {
                let objMeshGroupFirstPos = this.objMeshGroupFirstPoss[index];
                objMeshGroup.position.set(x, y, z).add(objMeshGroupFirstPos);
            });
            this._pointLast.copy(this.dymodePoint);
        }
        this.editor.listeners.signals.needRender.dispatch();

    }

    _copyEntitiyMap: { [key: string]: RenderMap } = {};

    firstStep = () => {
        if (this.objMeshGroupUuids == null || this.objMeshGroupUuids.length === 0) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        let objMeshGroups = [];
        this.extraContext.sceneContext.scene.children.forEach(obj => {
            if (this.objMeshGroupUuids.includes(obj.uuid)) {
                objMeshGroups.push(obj);
            }
        })
        if (!objMeshGroups || objMeshGroups.length == 0) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        this.objMeshGroups = objMeshGroups;
        for (let i = 0; i < this.objMeshGroups.length; i++) {
            let objMeshGroup = this.objMeshGroups[i];
            let objMeshGroupFirstPos = objMeshGroup.position.clone();
            this.objMeshGroupFirstPoss.push(objMeshGroupFirstPos);
        }

        this.listeners.signals.needCapture.dispatch(this.point_first);
        this.listeners.signals.orthogonal.dispatch(this.point_first);
        this.listeners.signals.polarTracking.dispatch(this.point_first);

        this.step++;
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode, this.point_first);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
        // this.extraContext.dymodeContext.state.target = this.point_first;
    }

    lastStep = () => {
        let first = this.point_first;
        let second = this.point_second;
        let dir = second.clone().sub(first.clone()).normalize();
        let dist = first.distanceTo(second);
        dir.multiplyScalar(dist);

        this.objMeshGroups.forEach((objMeshGroup, index) => {
            let objMeshGroupFirstPos = this.objMeshGroupFirstPoss[index];
            objMeshGroup.position.copy(objMeshGroupFirstPos).add(dir);
        });

        this.listeners.signals.onOpeCommandControlEnd.dispatch();
    }

    protected _dymodeActive = false;

    onDymodeChanged = (value: dymode) => {
        if (value.mode === DYMODE_MODE.POINT) {
            this.dymodePoint.set(value.x, value.y, value.z);
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        } else if (value.mode === DYMODE_MODE.DIST) {
            if (this.dymodePoint.distanceTo(this.point_first) < 1e-6) return;
            let dir = new Vector3().subVectors(this.dymodePoint, this.point_first).normalize();
            this.dymodePoint.addVectors(this.point_first, dir.multiplyScalar(value.dist));
            this._dymodeActive = true;
            this.onKeyMouseConfirm();
        }
    }

    onKeyMouseConfirm = () => {
        if (this.step === 0) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        } else if (this.step === 1) {
            this.point_first.copy(this.dymodePoint);
            // this.editor.dymodeControl.reset();
            this._dymodeActive = false;
            this.firstStep();
        } else if (this.step === 2) {
            // if (this._dymodeActive) {
            this.point_second.copy(this.dymodePoint);
            this._dymodeActive = false;
            this.lastStep();
            // }
        }
    }
}